import { accessCriteria } from '../util/authorization/index';
import { authRoles } from './roleGroups';

const DOCUMENT_TITLE = 'Mortgage Co Processing';

export const MCPRoutes = [
  {
    path: '/tax/mortgageco',
    name: 'Mortgage-Co-Processing',
    meta: {
      title: DOCUMENT_TITLE,
    },
    component: () => import('../views/MortgageCoProcessing.vue'),
    children: [
      {
        path: 'payments',
        name: 'Tax - Mortgage Company Payments',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/tax/MortgageCoProcessing/MortgageCompanyPayments.vue'),
      },
      {
        path: 'billrequests',
        name: 'Tax - Mortgage Company Bill Requests',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/tax/MortgageCoProcessing/MtgCoBillRequests.vue'),
      },
      {
        path: 'lockbox',
        name: 'Tax - Mortgage Company Lockbox',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/tax/MortgageCoProcessing/MortgageCoLockbox.vue'),
      },
      {
        path: 'export',
        name: 'Tax - Mortgage Company Export',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/tax/MortgageCoProcessing/MortgageCoExport.vue'),
      },
    ],
  },
];

MCPRoutes.forEach((element, index) => {
  MCPRoutes[index].beforeEnter = async (to, from, next) => {
    await accessCriteria([...authRoles.TaxRead, ...authRoles.MortgageCoAuth], next);
  };
});

export default MCPRoutes;
